import styled from "styled-components";
import ContentLoader from "react-content-loader";

const LoaderItem = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #f9f9f9;
  border-radius: 4px;
  margin-bottom: 25px;
  padding: 20px 26px 20px 20px;
`;

export const ArticlesLoader = ({ count = 5, ...props }) => {
  return (
    <div {...props}>
      {Array.from({ length: count }).map((_, index) => (
        <LoaderItem key={index}>
          <ContentLoader
            viewBox="0 0 1000 24"
            height="24"
            width="100%"
            speed={2}
            preserveAspectRatio="none"
          >
            <rect x="0" y="4" rx="3" ry="3" width="750" height="16" />
            <rect x="970" y="7" rx="4" ry="4" width="30" height="16" />
          </ContentLoader>
        </LoaderItem>
      ))}
    </div>
  );
};

